import { MutualFundTableData } from '../types/mutualFund';
import MutualFundTable from './MutualFundTable';

interface MutualFundMarksCardProps {
  tableData: MutualFundTableData;
  // selectedReportingPeriod?: string;
  // reportingPeriodOption?: string[];
}

export default function MutualFundMarksCard({
  tableData,
  // selectedReportingPeriod = '2024_Q4',
  // reportingPeriodOption = [],
}: MutualFundMarksCardProps) {
  return (
    <div className="mutual-fund-marks mt-6 px-4 sm:px-12 md:px-12">
      <div className="border border-gray-200 rounded-lg">
        <div className="border-b border-gray-200 p-4">
          <h2 className="text-lg font-semibold">Mutual Fund Marks</h2>
        </div>

        {/* Reporting Period Section */}
        {/*
        <div className="p-4 border-b border-gray-200">
          <div className="flex justify-between items-center flex-wrap gap-4">
            <div className="flex items-center space-x-2">
              <span className="text-sm">Reporting Period:</span>
              <select
                value={selectedReportingPeriod}
                className="w-[230px] border border-gray-300 rounded px-2 py-1 text-sm"
              >
                {reportingPeriodOption.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        */}

        {/* Table Section */}
        <div className="p-4">
          <MutualFundTable data={tableData} />
        </div>
      </div>
    </div>
  );
}
